import { TrackSchema } from '../../../types/schema';
import { TRACK_TEMPOS } from '../../../constants';
import { ApiCatalogueType } from '../../../types/user';
import {
  CatalogFilter,
  FindFiltersInput,
  FindTracksQueryVariables,
  PaginationInput,
} from '../../../graphql/generated-types/graphql';

/** Get BPM range for a selected tempo label */
export const getTempoRange = ({ tempo }: TrackSchema): [number, number] => {
  const tempoRange = TRACK_TEMPOS.find((t) => t.label.toLowerCase() === tempo.toLowerCase());

  if (tempoRange && tempoRange.range) {
    const [min, max] = tempoRange.range;

    return [min, max];
  }

  // If there's no range found, just return the full range of BPMs
  return [0, 300];
};

/** Generate search params for a selected tempo label */
export const getTempoHref = (track: TrackSchema) => {
  const [min, max] = getTempoRange(track);

  return `/search?tempoMin=${min}&tempoMax=${max}`;
};

/** Generate search params for a selected BPM */
export const getBpmHref = ({ bpm }: TrackSchema) => {
  return `/search?tempoMin=${bpm}&tempoMax=${bpm}`;
};

/** Generate search params for a selected genre */
export const getGenreOrMoodHref = (filterType: 'genre' | 'mood', tagSlug: string) => {
  return `/search?${filterType}=${tagSlug}`;
};

/**
 * Convert api-backend catalogue types to fit graphql schema
 */
export const parseCatalogueType = (catalogueType: ApiCatalogueType) => {
  switch (catalogueType) {
    case 'PREMIUM':
      return CatalogFilter.Chart;
    case 'INCLUDED':
      return CatalogFilter.Production;
    default:
      return null;
  }
};

export type SearchField = keyof FindTracksQueryVariables | keyof PaginationInput | keyof FindFiltersInput;

export const integerKeys: SearchField[] = ['size', 'from', 'durationMin', 'durationMax', 'tempoMin', 'tempoMax'];
export const booleanKeys: SearchField[] = [
  'brandSponsored',
  'brandedContent',
  'explicit',
  'featured',
  'instrumental',
  'hideNotAvailableIn',
  'dailymotion',
  'facebook',
  'instagram',
  'linkedin',
  'snapchat',
  'twitch',
  'twitter',
  'vimeo',
  'youtube',
  'TikTok',
  'podcasting',
];

export const castKeyPair = (key: SearchField, value: string) => {
  switch (true) {
    case integerKeys.indexOf(key) !== -1:
      return parseInt(value);

    case booleanKeys.indexOf(key) !== -1:
      return value === 'true';

    case value === 'null':
      return null;

    default:
      return value;
  }
};

export const formatGqlPlaylist = (playlist: any) => {
  let images = { identity: undefined };

  if (playlist.images && playlist.images.length) {
    images = { identity: playlist.images[0].identity };
  }

  return {
    ...playlist,
    images,
    type: 'playlist',
    use_playlist_image: true,
  };
};
